import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { RadarIcon } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-zinc-100 gap-3" data-testid="auth-loading">
        <RadarIcon size={28} className="text-[#2F6DA3] animate-spin" />
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const isSA = user.platform_role === "super_admin";
  if (isSA && !["/governance", "/team"].includes(pathname)) return <Navigate to="/governance" replace />;
  if (!isSA && pathname === "/governance") return <Navigate to="/" replace />;
  return children;
}
